<template>
  <div class="geoM contentBack">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>地理标志</el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected"
        >地标商标管理
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="geoLeft2">
      <p>
        地标商标管理<span style="font-size: 12px"
          >({{ geoProlist.length }}项)</span
        >
      </p>
      <div v-if="leftScroll == 1" class="topBlank"></div>
      <div
        class="geoProBox"
        v-for="(item, index) of geoProlist"
        :key="index"
        @click="imgSelected(index)"
        :class="{ lll: imgclick == index }"
      >
        <!-- <div> -->
        <!-- <img
            :class="{
              notClick: imgclick !== index,
              imgClick: imgclick == index,
            }"
            :src="require(`../assets/imgs/products/${item.product}.jpg`)"
          /> -->
        <!-- </div> -->
        <div style="width: 100%; background: #eeeeee; margin: 0">
          <img style="margin: 16px 0" :src="item.anImg" />
        </div>
        <p
          class="h1"
          :style="{ color: imgclick == index ? '#0064D0' : '#000' }"
        >
          {{ item.ti }}
        </p>
        <p class="h2">商标号码：{{ item.an }}</p>
        <p class="h3">{{ item.ic }}</p>
      </div>
    </div>
    <div class="geoRight">
      <div class="alertType">
        <div
          :class="{ chooseAlert: alert == 0 }"
          @click="alertClick(0)"
          style="border-left: 1px solid #dcdfe6; border-top: 1px solid #dcdfe6"
        >
          用标企业
        </div>
        <div :class="{ chooseAlert: alert == 1 }" @click="alertClick(1)">
          商标详情
        </div>
      </div>
      <!-- 用标企业 -->
      <div v-if="alert == 0" class="alertResult alertResult1">
        <div class="listTitle">企业列表</div>
        <div class="alrtbtn">
          <el-button @click="daochu">导出Excel</el-button>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
          @sort-change="sort"
        >
          <el-table-column type="selection" width="40" :resizable="false">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="企业名称"
            prop="ap"
            min-width="140"
            show-overflow-tooltip
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="法人代表"
            prop="frdb"
            :resizable="false"
            min-width="80"
          ></el-table-column>
          <el-table-column
            label="注册日期"
            prop="clrq"
            sortable="custom"
            :resizable="false"
            min-width="103"
          ></el-table-column>
          <el-table-column
            label="注册资金(万元)"
            prop="zczb"
            :resizable="false"
            min-width="120"
          ></el-table-column>
          <el-table-column
            label="注册地址"
            :resizable="false"
            prop="apad"
            min-width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所属区域"
            :resizable="false"
            prop="cnty"
            min-width="77"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="检验状态"
            :resizable="false"
            prop="inspectionStatus"
            min-width="77"
          ></el-table-column>
          <el-table-column
            label="检验结果"
            prop="inspectionResult"
            min-width="77"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="检验日期"
            prop="inspectionDate"
            min-width="95"
            :resizable="false"
          ></el-table-column>
          <el-table-column
            label="最近检验记录日期"
            prop="inspectionRecordDate"
            min-width="140"
            :resizable="false"
          ></el-table-column>
          <el-table-column label="操作" min-width="150" :resizable="false">
            <template slot-scope="scope">
              <div class="changeAlert">
                <button
                  style="margin-right: 10px; width: 62px"
                  @click="checkNote(scope.row)"
                >
                  检验记录
                </button>
                <button @click="checkHis(scope.row)" style="width: 62px">
                  检验历史
                </button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 商标详情 -->
      <div
        v-if="alert == 1"
        class="alertResult alertResult1"
        style="min-height: 621px"
      >
        <div class="listTitle">商标详情</div>
        <div class="geosbdetail">
          <!-- 商标图片 -->
          <div
            style="
              border-right: 1px solid #dcdfe6;
              width: 33%;
              padding: 33px 21px;
            "
          >
            <div style="border: 1px solid #dcdfe6">
              <img
                :src="tm.anImg"
                style="width: 100%; margin: 30px 0"
              />
            </div>
            <p
              style="
                font-size: 14px;
                color: #000000;
                font-weight: 700;
                text-align: center;
                margin-top: 18px;
              "
            >
              商标图样
            </p>
          </div>
          <!-- 内容 -->
          <div style="padding: 33px 21px">
            <table>
              <tr>
                <td>
                  商标名称：<span>{{ tm.ti }}</span>
                </td>
                <td>
                  国际分类：<span>{{ tm.ic }}</span>
                </td>
                <td>
                  商标号码：<span>{{ tm.an }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  申请状态：<span>{{
                    { "1": "在审", "2": "有效", "3": "无效" }[tm.ls]
                  }}</span>
                </td>
                <td>
                  申请日期：<span>{{ tm.apd }}</span>
                </td>
                <td>
                  初审日期：<span>{{ tm.pd }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  注册日期：<span>{{ tm.gd }}</span>
                </td>
                <td>
                  初审公告：<span>{{ tm.pdvl }}</span>
                </td>
                <td>
                  注册公告：<span>{{ tm.gdvl }}</span>
                </td>
              </tr>
              <tr>
                <td>后期指定：<span></span></td>
                <td>
                  商标类型：<span>{{
                    {
                      "0": "未知",
                      "1": "普通",
                      "2": "证明",
                      "3": "集体",
                      "4": "特殊",
                    }[tm.tmty]
                  }}</span>
                </td>
                <td>
                  申请方式：<span>{{ tm.apMethod }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  专用权期限：<span>{{
                    tm.gd ? tm.gd + "——" + tm.ed : ""
                  }}</span>
                </td>
              </tr>
            </table>
            <ul>
              <li>
                申请人名称(中)：<span>{{ tm.ap }}</span>
              </li>
              <li>
                申请人地址(中)：<span>{{ tm.apad }}</span>
              </li>
              <li>
                代理机构：<span>{{ tm.ag }}</span>
              </li>
              <li>
                类似群组：<span>{{ tm.grp }}</span>
              </li>
              <li>
                商品/服务列表：<span>{{ tm.spfw }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------popBOX---------- -->
    <!-- 检验记录 -->
    <div v-if="checkBox" class="popBoxMask"></div>
    <div v-if="checkBox" class="popBox" style="min-width: 723px">
      <div class="boxHeader">
        检验记录
        <i class="el-icon-close" @click="closeTkCheck"> </i>
      </div>
      <div class="boxContent">
        <div class="listTitle titleBold">录入信息</div>
        <div class="boxForm">
          <div class="checkform">
            <div style="width: 51%">
            <span style="color:red;">*</span>  <span>检验记录日期：</span
              ><el-date-picker
                v-model="notedate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                disabled
              >
              </el-date-picker>
            </div>
            <div style="width: 49%">
            <span style="color:red;">*</span>  <span>检验记录员：</span
              ><el-input placeholder="录入记录员" v-model="checkman"></el-input>
            </div>
          </div>
          <div class="checkform" style="margin-top: 18px">
            <div style="width: 49%; margin-left: 27px">
              <span style="color:red;">*</span>   <span>检验日期：</span
              ><el-date-picker
                v-model="checkdate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
            <div style="width: 45%">
            <span style="color:red;">*</span>  <span style="margin-right: 10px">检验结果：</span>
              <el-radio v-model="radio" label="1">合格</el-radio>
              <el-radio v-model="radio" label="0">不合格</el-radio>
            </div>
          </div>
          <!-- 上传 -->
          <div
            class="checkform"
            style="margin-top: 18px; justify-content: unset"
          >
            <span style="color:red;">*</span> <span >检验文件：</span>
            <div class="upload_demo">
              <div>
                <i class="el-icon-upload2" style="margin-right: 5px"></i>
                <span>上传文件</span>
              </div>
              <span>暂支持：Word、PDF、Excel</span>
              <input
                type="file"
                ref="clearFile"
                @change="getFile($event)"
                multiple="multiplt"
                class="add-file-right-input"
                accept=".docx,.doc,.pdf,.xlsx,.xls"
              />
            </div>
          </div>
          <!-- 上传文件列表 -->
          <div v-if="fileList.length > 0" class="filelist">
            <div v-for="(ele, eleindex) of fileList" :key="eleindex">
              <i class="el-icon-paperclip" style="margin-right: 6px"></i>
              <span>{{ ele }}</span>
              <i class="el-icon-close" @click="deleteupload(eleindex)"></i>
            </div>
          </div>
        </div>
        <div class="reBtnb">
          <el-button @click="quxiao">取消</el-button>
          <el-button @click="submitAddFile">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 检验历史 -->
    <div v-if="checkHistory" class="popBoxMask"></div>
    <div v-if="checkHistory" class="popBox" style="min-width: 723px">
      <div class="boxHeader">
        检验历史
        <i class="el-icon-close" @click="closeTkCheck2"> </i>
      </div>
      <div class="boxContent chekcB">
        <div class="checkT"><span>检验记录时间</span><span>检验详情</span></div>
        <div class="checkC" v-for="(item, index) of history" :key="index">
          <div>{{ item.inspectionRecordDate }}</div>
          <div class="bluecircle"></div>
          <div>
            检验时间：{{ item.inspectionDate }}；检验结果：{{
              item.inspectionResult == "1" ? "合格" : "不合格"
            }}；检验记录员：{{ item.inspectionRecorder }}； 检验报告：<span>
              <i class="el-icon-paperclip"></i>
              <span
                v-for="(doc, docindex) of item.inspectionDoc.split(';')"
                :key="docindex"
                @click="openDoc(doc)"
                >{{ doc }};</span
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- ------------------------- -->
  </div>
</template>
<script>
// import PDFJS from 'pdfjs-dist'
export default {
  data() {
    return {
      geoProlist: [],
      imgclick: 0,
      alert: 0,
      tableData: [],
      multipleSelection: [],
      productt: "",
      checkBox: false,
      radio: "1",
      addArr: [],
      checkdate: "",
      notedate: "",
      checkman: "",
      ap: "",
      fileList: [],
      checkHistory: false,
      history: [],
      leftScroll: 0,
      orderType: "",
      tm: {},
      an: "",
    };
  },
  methods: {
    openDoc(doc) {
      
      if (
        doc.split(".").indexOf("pdf") == -1 &&
        doc.split(".").indexOf("PDF") == -1
      ) {
         window.open('http://zscqapi.mianyang.cn/fx/product/download?filePath='+encodeURI("/opt/myfxfiles/") +doc+'&isOnLine=false&token='+localStorage.getItem('token'))

      } else {
    
        window.open('http://zscqapi.mianyang.cn/fx/product/download?filePath='+encodeURI("/opt/myfxfiles/") +doc+'&isOnLine=true&token='+localStorage.getItem('token'))
      }
    },
    /////////////////////////
    closeTkCheck() {
      this.checkBox = false;
    },
    closeTkCheck2() {
      this.checkHistory = false;
    },
    // 获取地理标志产品
    getGeoProducts() {
      return new Promise((resolve, error) => {
        this.$get("/product/landmarkTm", {
          token: localStorage.getItem("token"),
        }).then((res) => {
          this.geoProlist = res.data;
          resolve();
        });
      });
    },
    imgSelected(index) {
      // debugger;
      this.imgclick = index;
      this.productt = this.geoProlist[index].ti;
      this.an = this.geoProlist[index].an;
      this.getmarkProduct();
      this.getTmDetails();
    },
    alertClick(val) {
      this.alert = val;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取地理标志产品用标企业
    getmarkProduct() {
      this.$get("/product/landmarkProUserAp", {
        token: localStorage.getItem("token"),
        product: this.productt,
        type: 1,
        orderType: this.orderType,
      }).then((res) => {
        this.tableData = res.data;
        this.tableData.forEach((ele) => {
          if (ele.inspectionStatus == "0") {
            ele.inspectionStatus = "未检验";
          } else if (ele.inspectionStatus == "1") {
            ele.inspectionStatus = "已检验";
          }
          if (ele.inspectionResult == "1") {
            ele.inspectionResult = "合格";
          } else if (ele.inspectionResult == "0") {
            ele.inspectionResult = "不合格";
          }
        });
      });
    },
    // 导出
    daochu() {
      if (this.multipleSelection.length > 0) {
          //  console.log('---',this.multipleSelection.length)
        let aps = [];
        this.multipleSelection.forEach((ele) => {
          aps.push(ele.ap);
        });
        aps = aps.join(";");
        // console.log('aps',aps)
        let aLink = document.createElement("a");
        aLink.href =
          this.$url +
          "product/proExport?token=" +
          localStorage.getItem("token") +
          "&aps=" +
          aps +
          "&type=" +
          "1" +
          "&orderType=" +
          this.orderType;
        aLink.click();
      } else {
        let aLink1 = document.createElement("a");
        aLink1.href =
          this.$url +
          "product/proExport?token=" +
          localStorage.getItem("token") +
          "&product=" +
          this.productt +
          "&type=" +
          "1" +
          "&orderType=" +
          this.orderType;
        aLink1.click();
      }
    },
    // 检验记录
    checkNote(row) {
      // console.log('---',row)

      this.checkBox = true;
      this.ap = row.ap;
      this.radio = '1'
    },
    // 监听文件上传，对文件类型再次进行限制
    getFile(event) {
      var file = event.target.files;
      for (var k in file) {
        if (file.hasOwnProperty(k)) {
          this.fileList.push(file[k].name);
        }
      }
      // 循环文件列表
      for (let i = 0; i < file.length; i++) {
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (
            ext != "pdf" &&
            ext != "doc" &&
            ext != "docx" &&
            ext != "xlsx" &&
            ext != "xls"
          ) {
          } else {
            this.addArr.push(file[i]);
          }
        } else {
        }
      }
    },
    // 将数据提交给后台
    submitAddFile() {
      if (this.addArr.length == 0) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      }
      var formData = new FormData();
      formData.append("inspectionResult", this.radio);
      formData.append("inspectionDate", this.checkdate);
      formData.append("inspectionRecorder", this.checkman);
      formData.append("ap", this.ap);
      formData.append("landmarkType", 1);
      formData.append("token", localStorage.getItem("token"));
      for (var i = 0; i < this.addArr.length; i++) {
        formData.append("files", this.addArr[i]);
      }
      this.axios.post("/product/upload", formData).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            type: "success",
            message: "更新检验记录成功!",
          });
          this.checkBox = false;
          // this.reload()
          this.imgSelected(this.imgclick);
        }
      });
    },
    quxiao() {
      this.checkBox = false;
    },
    deleteupload(index) {
      this.fileList.splice(index, 1);
      this.addArr.splice(index, 1);
    },
    checkHis(row) {
      this.checkHistory = true;
      this.$get("/product/listIns", {
        token: localStorage.getItem("token"),
        ap: row.ap,
        type: 1,
      }).then((res) => {
        this.history = res.data;
      });
    },
    // 监听左侧滚动条
    scrollHandle() {
      let scrollObj = document.querySelector(".geoLeft2"); // 获取滚动区域
      // let clientHeight = scrollObj.clientHeight; // 容器的高度
      let scrollTop = scrollObj.scrollTop; // 已滚动的距离
      if (scrollTop > 50) {
        this.leftScroll = 1;
      } else {
        this.leftScroll = 0;
      }
    },
    sort(colum) {
      this.orderType = colum.order;
      if (this.orderType == "descending") {
        this.orderType = "desc";
      } else if (this.orderType == "ascending") {
        this.orderType = "asc";
      }
      this.getmarkProduct();
    },
    // 获取商标详情
    getTmDetails() {
      this.$get("/product/landmarkTmInfo", {
        token: localStorage.getItem("token"),
        product: this.an,
      }).then((res) => {
        this.tm = res.data;
        // if (this.tm.ti == "仁寿枇杷;RENSHOU LOQUAT") {
        //   this.tm.ti = "仁寿枇杷;RENS...";
        // }
      });
    },
  },
  created() {},
  watch: {
    checkBox() {
      if (this.checkBox == false) {
        (this.radio = ""),
          (this.addArr = []),
          (this.checkdate = ""),
          (this.checkman = ""),
          (this.ap = ""),
          (this.fileList = []);
      }
    },
  },
  mounted() {
    // 监听左侧滚动条
    let dom = document.getElementsByClassName("geoLeft2")[0];
    if (dom) {
      dom.addEventListener("scroll", this.scrollHandle, true);
    }
    ////////////////
    this.getGeoProducts().then(() => {
      this.productt = this.geoProlist[0].ti;
      this.an = this.geoProlist[0].an;
      this.getmarkProduct();
      this.getTmDetails();
    });
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    this.notedate = year + "/" + month + "/" + day;
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle);
  },
};
</script>
<style>
.geoM {
  display: flex;
  justify-content: space-between;
  background: #f2f2f2;
}
.geosbdetail table {
  margin-bottom: 35px;
}
.geosbdetail table td {
  font-size: 14px;
  color: #474747;
  font-weight: 700;
  padding-bottom: 26px;
}
.geosbdetail ul {
  list-style: none;
  font-size: 14px;
  color: #474747;
  font-weight: 700;
  border-top: 1px solid #dddddd;
  padding-top: 35px;
}
.geosbdetail ul > li {
  margin-bottom: 26px;
}
.geosbdetail span {
  font-weight: 400;
  font-size: 14px;
  margin-left: 20px;
  margin-right: 20px;
}
.geoLeft2 {
  width: 12.5%;
  height: 100%;
  overflow-y: auto;
  background: #fff;
  position: relative;
}
.geoLeft2 > p {
  font-size: 16px;
  color: #000;
  margin: 17px 0 12px 20px;
}
.geosbdetail {
  border: 1px solid rgb(220, 223, 230);
  display: flex;
  height: 91%;
}
@media (max-width: 1400px) {
  .geoLeft2 > p {
    font-size: 15px !important;
  }
  /* .geosbdetail span {
    margin-left: 0px;
    margin-right: 10px;
  } */
}
@media (max-width: 1500px) {
  .geosbdetail span {
    margin-left: 0px;
    margin-right: 10px;
  }
}
@media (min-width: 1850px) {
  .geosbdetail span {
    margin-left: 50px;
    margin-right: 50px;
  }
}
</style>